import { useEffect, useState } from "react";
import { useLayerService } from "../../../../../hooks";
import { CensusCategory } from "../../../../../types/Census/CensusCategory";
import useGetCensusParams from "./GetCensusParams";
import CensusUrlKeys from "../../../../../constant/CensusUrlKeys";

const useGetCensusCategories = () => {
  const [categories, setCategories] = useState<CensusCategory[]>([]);
  const [loading, setLoading] = useState(false);
  const { outputAreaId, year, categoryId, columnId, clearParam } = useGetCensusParams();
  const layerService = useLayerService();

  useEffect(() => {
    if (outputAreaId != null && year != null) {
      setLoading(true);
      layerService.GetCensusCategories(year, outputAreaId).then((response) => {
        setCategories(response);
        setLoading(false);

        if (categoryId != null) {
          const matchedCategory = response.find((c) => c.categoryId === categoryId);
          const categoryHasData = matchedCategory?.columns.some((col) => col.haveData) ?? false;

          if (!categoryHasData) {
            clearParam(CensusUrlKeys.CATEGORY, CensusUrlKeys.COLUMN);
          } else if (columnId != null) {
            const matchedColumn = matchedCategory?.columns.find((col) => col.columnId === columnId);
            if (!matchedColumn?.haveData) {
              clearParam(CensusUrlKeys.COLUMN);
            }
          }
        }
      });
    }
  }, [outputAreaId, year]);

  return { categories, loading };
};

export default useGetCensusCategories;
